import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExpertiseSection from './components/ExpertiseSection';
import FeatureSection from './components/FeatureSection';
import StandardsSection from './components/StandardsSection';
import StatementSection from './components/StatementSection';
import ContactSection from './components/ContactSection';

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "LLN GROUP, UAB",
  "description": "A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.",
  "url": "https://llngroups.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pakrascio g. 10-111",
    "addressLocality": "Vilnius",
    "postalCode": "11342",
    "addressCountry": "LT"
  },
  "telephone": "+370 66803839",
  "email": "company@llngroups.com",
  "foundingLocation": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Vilnius",
      "addressCountry": "LT"
    }
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <main>
        <HeroSection />
        <AboutSection />
        <ExpertiseSection />
        <FeatureSection />
        <StandardsSection />
        <StatementSection />
        <ContactSection />
      </main>
    </>
  );
}